/** biome-ignore-all lint/performance/noBarrelFile: this module is the public entrypoint for user classification */
import { jwtDecode } from 'jwt-decode';

import { CookieService } from '@/app_lib/CookieService';

import { classifyUserFromCookieValues as classify } from './classifyUser';
import { type CookieGetter, type JwtDecoder, UNKNOWN_USER_CLASSIFICATION, type UserClassification } from './types';

type GetUserClassificationOptions = {
  getCookie?: CookieGetter;
  decodeJwt?: JwtDecoder;
  fortuneEmailDomains?: string[];
};

export const getUserClassification = (options: GetUserClassificationOptions = {}): UserClassification => {
  try {
    if (typeof document === 'undefined') {
      return UNKNOWN_USER_CLASSIFICATION;
    }

    const getCookie = options.getCookie ?? CookieService.get;
    const decodeJwt = options.decodeJwt ?? (jwtDecode as JwtDecoder);

    const utp = getCookie('__utp');
    const cookiePianoUid = getCookie('pianoUid');
    let pianoUid = cookiePianoUid;
    if (!pianoUid && utp) {
      try {
        const decoded = decodeJwt<{ sub?: unknown }>(utp);
        const tokenSub = typeof decoded?.sub === 'string' ? decoded.sub.trim() : '';
        if (tokenSub) {
          pianoUid = tokenSub;
        }
      } catch {
        // fall back to cookie value
      }
    }

    return classify(
      {
        pianoAccess: getCookie('pianoAccess'),
        pianoUid,
        utp,
      },
      { decodeJwt, fortuneEmailDomains: options.fortuneEmailDomains },
    );
  } catch {
    return UNKNOWN_USER_CLASSIFICATION;
  }
};

export const classifyUser = getUserClassification;

export { classifyUserFromCookieValues } from './classifyUser';
export type { CookieGetter, JwtDecoder, UserClassification, UserState, UserType } from './types';
export { UNKNOWN_USER_CLASSIFICATION } from './types';
